var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.25a5.246 5.246 0 0 1-5.25 5.25l.787-1.313M1.5 6.75A5.246 5.246 0 0 1 6.75 1.5l-.787 1.313M10.275 3.338l2.985 1.725 2.955-1.718M13.26 8.115v-3.06",
    stroke: "#9AA0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.555 1.657-1.8.998c-.405.225-.743.795-.743 1.26V5.82c0 .465.33 1.035.743 1.26l1.8.998c.383.217 1.012.217 1.402 0l1.8-.998c.405-.225.743-.795.743-1.26V3.915c0-.465-.33-1.035-.743-1.26l-1.8-.997c-.382-.21-1.012-.21-1.402 0zM1.762 11.588l2.978 1.725 2.962-1.718M4.74 16.365v-3.06",
    stroke: "#9AA0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m4.043 9.908-1.8.997c-.405.225-.743.795-.743 1.26v1.905c0 .465.33 1.035.743 1.26l1.8.998c.382.217 1.012.217 1.402 0l1.8-.998c.405-.225.742-.795.742-1.26v-1.905c0-.465-.33-1.035-.742-1.26l-1.8-.997c-.39-.21-1.02-.21-1.402 0z",
    stroke: "#9AA0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterIcon);
export default __webpack_public_path__ + "static/media/master_icon.f9c7d4d4d60808e925b8635987923fb4.svg";
export { ForwardRef as ReactComponent };